export enum DeliveryStatusEnum {
    READY_TO_DELIVER = 'ready_to_deliver',
    COMPLETE = 'complete',
}